
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Device } from '~/interfaces/device.interface';
import { DevicesModule } from '~/store/modules/devices';

@Component
export default class SwitchDebugMode extends Vue {
    @Prop() device!: Device;

    get debugValue() {
        return !!this.device.debug_enabled;
    }

    set debugValue(value: boolean) {
        DevicesModule.setDebugMode({ deviceId: this.device.id, value });
    }
}
